import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/shared/lib/utils';

const Content = TooltipPrimitive.Content;

export const TooltipContent = ({
  className,
  sideOffset = 5,
  ref,
  ...props
}: React.ComponentProps<typeof Content>) => (
  <Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'fade-in-0 zoom-in-95 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-w-[320px] animate-in overflow-hidden rounded-lg bg-surface-inverse px-2 py-1.5 text-text-inverse text-xs shadow-md data-[state=closed]:animate-out',
      className,
    )}
    {...props}
  />
);

TooltipContent.displayName = Content.displayName;
